import { createGlobalStyle } from 'styled-components';
export const GlobalStyle = createGlobalStyle `
  * {
    /* font-size: 62.5%; */
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    font-family: ${({ theme }) => theme.fonts.body};
    text-underline-position: from-font;
  }
`;
//# sourceMappingURL=global-style.js.map